export default "__VITE_PUBLIC_ASSET__c7bf65c8__"